const socialScienceColors = {
  SOCIALS_50: '#E8F6E7',
  SOCIALS_100: '#C9E8C5',
  SOCIALS_200: '#A5D9A0',
  SOCIALS_600: '#3EA535',
}

export default socialScienceColors
